import { validateSignature } from '@/validators/signature'
import { validateProductPersonChooserLegacy } from '@/validators/product-person-chooser-legacy'
import { validateTautology } from '@broker-as/acquisit-ui-vue/library'

export const VALIDATORS = {
	'product-person-chooser-legacy': validateProductPersonChooserLegacy,
	'signature': validateSignature,
	'elhub-controller': validateTautology,
}